import { VITALS_ACTIVITY_TYPE } from '../../constants';

export const EMPTY_VITALS_CARD = 'empty_vitals_card';

export const TYPE_CARDS = [
  { type: VITALS_ACTIVITY_TYPE.STEPS },
  { type: VITALS_ACTIVITY_TYPE.DISTANCE },
  { type: VITALS_ACTIVITY_TYPE.BMI },
  { type: VITALS_ACTIVITY_TYPE.WEIGHT },
  { type: VITALS_ACTIVITY_TYPE.HEIGHT },
  { type: VITALS_ACTIVITY_TYPE.SATURATION },
  { type: VITALS_ACTIVITY_TYPE.HEART_RATE },
  { type: VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE },
  { type: VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE },
  { type: VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA },
  { type: VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE },
  { type: VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE },
];



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/VitalsActivity/ActivityCard/cards.js